module.exports = __webpack_public_path__ + "static/media/cassette-tape.b5ae78d1.svg";